"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _I18n = _interopRequireDefault(require("I18n"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _draftExtend = require("draft-extend");

var _draftJs = require("draft-js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _usageTracking = require("rich-text-lib/constants/usageTracking");

var _UITextToolbarSelect = _interopRequireDefault(require("UIComponents/editor/UITextToolbarSelect"));

var _constants = require("../lib/constants");

var _usageTracker = require("../tracking/usageTracker");

var Tracker;

var createBlockStyleOption = function createBlockStyleOption(_ref) {
  var style = _ref.style,
      name = _ref.name;
  return {
    text: _I18n.default.text("draftPlugins.blockStyle.tooltips." + name),
    value: style
  };
};

var createOptions = (0, _memoize.default)(function (headerStyles, miscStyles) {
  var options = [createBlockStyleOption(_constants.PLAIN_BLOCK)];

  if (Array.isArray(headerStyles)) {
    var styles = _constants.HEADER_TYPES.filter(function (style) {
      return headerStyles.indexOf(style.style) !== -1;
    });

    options.push.apply(options, (0, _toConsumableArray2.default)(styles.map(createBlockStyleOption)));
  } else {
    options.push.apply(options, (0, _toConsumableArray2.default)(_constants.HEADER_TYPES.map(createBlockStyleOption)));
  }

  if (Array.isArray(miscStyles)) {
    var _styles = _constants.MISC_TYPES.filter(function (style) {
      return miscStyles.indexOf(style.style) !== -1;
    });

    options.push.apply(options, (0, _toConsumableArray2.default)(_styles.map(createBlockStyleOption)));
  } else {
    options.push.apply(options, (0, _toConsumableArray2.default)(_constants.MISC_TYPES.map(createBlockStyleOption)));
  }

  return options;
});

var getBlockStylesDropdown = function getBlockStylesDropdown(_ref2) {
  var headerStyles = _ref2.headerStyles,
      miscStyles = _ref2.miscStyles,
      inputProps = _ref2.inputProps;

  var BlockStylesDropdown = function BlockStylesDropdown(_ref3) {
    var editorState = _ref3.editorState,
        onChange = _ref3.onChange,
        disabled = _ref3.disabled;
    var options = createOptions(headerStyles, miscStyles);

    var onStyleSelect = function onStyleSelect(e) {
      var style = e.target.value;

      var newState = _draftJs.RichUtils.toggleBlockType(editorState, style);

      onChange(_draftJs.EditorState.forceSelection(newState, newState.getSelection()));
      Tracker.track('draftFormatting', {
        action: _usageTracking.CHANGE_BLOCK_FORMAT,
        method: 'toolbar',
        value: style.toLowerCase()
      });
    };

    var currentBlockStyle = editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey()).getType();
    var value = currentBlockStyle;

    if (![].concat((0, _toConsumableArray2.default)(_constants.HEADER_TYPES), (0, _toConsumableArray2.default)(_constants.MISC_TYPES)).find(function (_ref4) {
      var style = _ref4.style;
      return style === currentBlockStyle;
    })) {
      value = _constants.PLAIN_BLOCK.style; // other block styles (list, atomic, etc.) handled by other plugins
    }

    return _react.default.createElement(_UITextToolbarSelect.default, Object.assign({}, inputProps, {
      className: "display-inline-block m-right-2",
      disabled: disabled,
      onChange: onStyleSelect,
      options: options,
      value: value
    }));
  };

  BlockStylesDropdown.propTypes = {
    disabled: _propTypes.default.bool,
    editorState: _propTypes.default.object,
    onChange: _propTypes.default.func
  };
  BlockStylesDropdown.defaultProps = {
    disabled: false
  };
  return BlockStylesDropdown;
};

var _default = function _default() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref5$headerStyles = _ref5.headerStyles,
      headerStyles = _ref5$headerStyles === void 0 ? null : _ref5$headerStyles,
      _ref5$miscStyles = _ref5.miscStyles,
      miscStyles = _ref5$miscStyles === void 0 ? null : _ref5$miscStyles;

  var inputProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Tracker = (0, _usageTracker.createTracker)();
  return (0, _draftExtend.createPlugin)({
    buttons: getBlockStylesDropdown({
      headerStyles: headerStyles,
      miscStyles: miscStyles,
      inputProps: inputProps
    }),
    displayName: 'BlockStyles',
    blockToHTML: {
      blockquote: {
        start: '<blockquote>',
        end: '</blockquote>'
      },
      'code-block': {
        start: '<pre>',
        end: '</pre>'
      }
    }
  });
};

exports.default = _default;
module.exports = exports.default;